import { Inbox } from "lucide-react";

export function EmptyState({ title = "Inget att visa", description, icon: Icon = Inbox, action }) {
  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border py-16 text-center"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-muted text-muted-foreground/60">
        <Icon className="h-6 w-6" />
      </div>
      <div>
        <p className="font-display text-base font-semibold">{title}</p>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}
